import keycloak from '../keycloak'

/*
 * Deletes ALL data of one patient (core DB, personal DB, optionally Keycloak).
 *
 * Deliberately not wired to any UI. Registered on window by index.js so it can be run from
 * the browser dev console by someone who knows it exists. The backend defaults to a dry run
 * and requires the CENTER_MANAGER role of the patient's clinic.
 *
 *   await __ifsDeletePatientData({ patientName: '11895' })                                   // dry run
 *   await __ifsDeletePatientData({ patientName: '11895', execute: true })                    // delete
 *   await __ifsDeletePatientData({ patientName: '11895', execute: true, deleteKeycloakUser: true })
 *
 * Further options: patientId (must match patientName when both are given),
 * allowMissingPersonal (commit even if the personal service holds no record).
 */
const deletePatientData = async ({ patientName, patientId, execute = false, deleteKeycloakUser = false, allowMissingPersonal = false } = {}) => {
	if (!patientName && !patientId) {
		throw new Error('patientName (pseudonym) or patientId is required')
	}

	const params = new URLSearchParams({
		...(patientName ? { patientName } : {}),
		...(patientId ? { patientId } : {}),
		dryRun: String(!execute),
		deleteKeycloakUser: String(deleteKeycloakUser),
		allowMissingPersonal: String(allowMissingPersonal)
	})

	const response = await fetch(`/api/v1/patient?${params.toString()}`, {
		method: 'DELETE',
		headers: {
			Accept: 'application/json',
			Authorization: `Bearer ${keycloak.token}`
		}
	})

	let result = {}
	try {
		result = await response.json()
	} catch (e) {
		result = { success: false, message: 'no JSON response' }
	}
	result.httpStatus = response.status

	if (result.rowsDeleted) {
		console.table(result.rowsDeleted)
	}
	console.log(execute ? (result.success ? 'DELETED' : 'NOT deleted') : 'DRY RUN', result)

	return result
}

export const registerPatientDeletionDevTool = () => {
	window.__ifsDeletePatientData = deletePatientData
}
